import { API } from 'service/API'

import { IVATResponseJSON } from './Vat'

export class VatService {
  API: API

  constructor(api: API) {
    this.API = api
  }

  validate = (vatId: string): Promise<IVATResponseJSON> => {
    return this.API.vat.validateVatId(vatId)
  }
}
